"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var common_hooks_1 = require("@l2p/common-hooks");
var Lockr = __importStar(require("lockr"));
var generateDateForTimer_1 = require("../generateDateForTimer");
var date_fns_1 = require("date-fns");
var SPECIAL_PROMO = 'promoDateTime';
var Timer = function () {
    var _a = (0, react_1.useState)(false), mounted = _a[0], setMounted = _a[1];
    var dateEndTimer = (0, react_1.useMemo)(function () {
        var existedDate = Lockr.get(SPECIAL_PROMO);
        var createNewTimerDate = function () {
            var newDateSpecialPromo = (0, generateDateForTimer_1.generateFutureDate)();
            Lockr.set(SPECIAL_PROMO, newDateSpecialPromo);
            return newDateSpecialPromo;
        };
        if (existedDate) {
            if ((0, date_fns_1.isAfter)(new Date(), new Date(existedDate)))
                return createNewTimerDate();
            else
                return existedDate;
        }
        else {
            return createNewTimerDate();
        }
    }, []);
    var time = (0, common_hooks_1.useTimer)({
        endDate: dateEndTimer,
    }).time;
    (0, react_1.useEffect)(function () {
        setMounted(true);
    }, []);
    if (!mounted)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.timer },
        time.hours,
        ":",
        time.minutes,
        ":",
        time.seconds));
};
exports.default = Timer;
